import { useService } from '@visiba/instantiation';
import { ReactNode, SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import { LocationSelectorService } from '@services/location_selector.service';
import type { OpenUrlWithKind } from '@api/generated/models';
import { useUser } from '@services/auth/use_user';

interface Props {
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
	url: string;
	requiresAuthentication: boolean;
	openWith: OpenUrlWithKind;
	children?: ReactNode;
	className?: string;
}

export function Routeable({
	requiresAuthentication,
	url,
	children,
	openWith,
	__TEMP__on_OPW_WebContentButton_proxy_invoke,
	className,
}: Props): JSX.Element {
	const locationSelectorService = useService(LocationSelectorService);
	const parsedUrl = openWith === 'IFrame' ? convertUrlToEmbeddedWebLink(locationSelectorService.location.route, url) : url;
	const user = useUser();

	function handleIntercept(event: SyntheticEvent<HTMLAnchorElement>): void {
		if (__TEMP__on_OPW_WebContentButton_proxy_invoke) {
			event.preventDefault();

			__TEMP__on_OPW_WebContentButton_proxy_invoke?.({
				url: openWith === 'IFrame' ? encodeURIComponent(url) : url,
				openUrlWith: openWith,
				requiresAuthentication: requiresAuthentication,
			});

			return;
		}

		if (window.__TEMP__overrideNavigation) {
			event.preventDefault();
			window.__TEMP__overrideNavigation(parsedUrl);

			return;
		}

		if (requiresAuthentication && user == null) {
			event.preventDefault();
			// todo: trigger login modal (not impl)

			return;
		}
	}

	if (openWith === 'NewTab' && url.includes('http')) {
		return (
			<a href={url} onClick={handleIntercept} target='_blank' rel='noreferrer' className={className}>
				{children}
			</a>
		);
	}

	if (openWith === 'SameTab' && url.includes('http')) {
		return (
			<a href={parsedUrl} onClick={handleIntercept} className={className}>
				{children}
			</a>
		);
	}

	if (openWith === 'IFrame') {
		if (window.__TEMP__overrideNavigation || __TEMP__on_OPW_WebContentButton_proxy_invoke) {
			return (
				<a href={parsedUrl} onClick={handleIntercept} className={className}>
					{children}
				</a>
			);
		}

		return (
			<Link to={parsedUrl} onClick={handleIntercept} className={className}>
				{children}
			</Link>
		);
	}

	if (window.__TEMP__overrideNavigation || __TEMP__on_OPW_WebContentButton_proxy_invoke) {
		return (
			<a href={url} onClick={handleIntercept} className={className}>
				{children}
			</a>
		);
	}

	return (
		<Link to={url} onClick={handleIntercept} className={className}>
			{children}
		</Link>
	);
}

function convertUrlToEmbeddedWebLink(prefix: string, url: string): string {
	return `${prefix}/ew?url=${encodeURIComponent(url)}`;
}
